import type {
  ICoordinate,
  IPlacePrediction,
  RydeUiUnit,
  RydeUiUnitDropdownCacheKey,
} from "@ryde/shared";

export interface IQuickAddStationFormModel {
  address: Partial<IPlacePrediction>;
  areaId: number;
  coordinate: ICoordinate;
}

export enum QuickStationFormFields {
  address = "address",
  areaId = "areaId",
  coordinate = "coordinate",
}

export interface IQuickStationSaveParams {
  address: string;
  areaId: number;
  coordinate: ICoordinate;
}

export interface IQuickStationForm {
  className?: string;
  closeQuickAdd: () => void;
  onSave: (data: IQuickStationSaveParams) => void;
}

export interface IUseCanQuickAddStation {
  name: string;
  dropItemsSource?: RydeUiUnit;
  suffixToEntity: RydeUiUnitDropdownCacheKey;
}
